export default {
  title: "Wachtwoord vergeten",
  input: {
    email: {
      label: "E-mailadres",
    },
  },
  button: {
    submit: "Verstuur e-mail",
    cancel: "Annuleren",
  },
  warning: {
    noEmail: "Voer uw e-mailadres in alstublieft.",
  },
  success: {
    emailSent: "Een e-mail met instructies is verstuurd.",
  },
  api: {
    email: {
      invalid: "Dit is geen geldig e-mailadres",
    },
  },
}
